import React from 'react';
import { useParams } from 'react-router-dom';
import { useQueries } from '@tanstack/react-query';

import ContentPage from 'components/ContentView/ContentPage/ContentPage';
import useAlerts from 'utils/hooks/useAlerts';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';
import { ResourceType } from 'utils/types';
import { org2alarms } from './queries';
import RelationTable from 'components/RelationTable/RelationTable';
import useRelations from 'utils/hooks/useRelations';
import { useRelationData, createRelationQueryData, createOrgOwnerRelationQueryData } from './queries';
import { alarmKeys } from 'components/Admin/Alarms/queries';


const OrgToAlarmRelations = ({ breadcrumbs }) => {
  const api = useAPI();
  const { orgId } = useParams();
  const [alerts,, addErrorAlert] = useAlerts();

  const [alarmsQuery, alarmsRelationQuery, alarmsOwnerQuery] = useQueries({
    queries: [
      { queryKey: alarmKeys.alarms(), queryFn: createQueryRequest(api.core.getAlarms) },
      { queryKey: org2alarms.org(createRelationQueryData(ResourceType.Alarm, orgId)), queryFn: createQueryRequest(api.core.findRelationships) },
      { queryKey: org2alarms.org(createOrgOwnerRelationQueryData(ResourceType.Alarm)), queryFn: createQueryRequest(api.core.findRelationships) }
    ]
  });

  const alarms = useRelationData({
    isLoading: alarmsQuery.isLoading || alarmsRelationQuery.isLoading || alarmsOwnerQuery.isLoading,
    resources: alarmsQuery.data,
    resourceRelations: alarmsRelationQuery.data,
    ownedRelations: alarmsOwnerQuery.data,
    resourceType: ResourceType.Alarm
  });

  const updatedAlarms = alarms.map((alarm) => {
    return {
      ...alarm,
      displayName: alarm.name
    };
  });
  const { updateRelations, deleteRelations } = useRelations({
    refetchFn: alarmsRelationQuery.refetch,
    queryKey: org2alarms.org(createRelationQueryData(ResourceType.Alarm)),
    onError: addErrorAlert
  });

  return (
    <ContentPage
      breadcrumb={breadcrumbs}
    >
      { alerts }
      <RelationTable
        orgId={orgId}
        resources={updatedAlarms}
        isLoading={alarmsQuery.isLoading || alarmsRelationQuery.isLoading || alarmsOwnerQuery.isLoading}
        updateRelationsFn={updateRelations.mutate}
        deleteRelationsFn={deleteRelations.mutate}
      />
    </ContentPage>
  );
};

export default OrgToAlarmRelations;
